const Col = ({ className, children, ...props }) => (
  <div className={`col${className ? ` ${className}` : ''}`} {...props}>
    {children}
  </div>
)

export default Col
